<main class="edit">
	<section class="edit__card">
		<button
			class="edit__dismiss"
			aria-label="Close Edit Vet Modal"
			data-quat="action_modalDismiss"
			(click)="close()"
		>
			<svg
				aria-hidden="true"
				viewBox="0 0 56 56"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<rect
					width="23.759"
					height="2.64"
					rx="1"
					transform="rotate(-45 52.145 -4.8)"
					fill="#333"
				/>
				<rect
					width="23.759"
					height="2.64"
					rx="1"
					transform="rotate(45 -12.266 34.12)"
					fill="#333"
				/>
			</svg>
		</button>
		<h1
			class="edit__heading"
			data-quat="value_addEditHeading"
		>{{ showQuestionaire ? 'Delete Vet Clinic?' : 'Edit Vet Clinic' }}</h1>
		<ng-container *ngIf="!showQuestionaire">
			<form
				[formGroup]="editForm"
				class="edit__form"
			>
				<div
					role="presentation"
					class="input-group"
				>
					<label
						for="vetClinic"
						class="input-group__label"
						data-quat="label_vetClinic"
					>Name</label>
					<input
						formControlName="vetClinic"
						type="text"
						name="vetClinic"
						id="vetClinic"
						class="input-group__input"
						data-quat="input_vetClinic"
					>
				</div>
				<div
					role="presentation"
					class="input-group"
				>
					<label
						for="otherPetNames"
						class="input-group__label"
						data-quat="label_otherPetNames"
					>Other Pet Names</label>
					<input
						formControlName="otherPetNames"
						type="text"
						name="otherPetNames"
						id="otherPetNames"
						class="input-group__input"
						maxlength="100"
						data-quat="input_otherPetNames"
					>
				</div>
				<div
					role="presentation"
					class="input-group"
				>
					<label
						for="otherOwnerNames"
						class="input-group__label"
						data-quat="label_otherOwnerNames"
					>Other Owner Names</label>
					<input
						formControlName="otherOwnerNames"
						type="text"
						name="otherOwnerNames"
						id="otherOwnerNames"
						class="input-group__input"
						maxlength="100"
						data-quat="input_otherOwnerNames"
					>
				</div>
			</form>
			<section class="edit__actions">
				<button
					class="edit__actions-item m--delete m--bordered m--justify-center"
					data-quat="action_deleteClinic"
					(click)="delete()"
				>Delete</button>
				<button
					[disabled]="editForm.pristine || editForm.invalid"
					class="c-cta edit__actions-item m--save m--justify-start"
					data-quat="action_saveChanges"
					(click)="save()"
				>Save</button>
			</section>
		</ng-container>
		<ng-container *ngIf="showQuestionaire">
			<form class="edit__form">
				<div role="presentation">
					<label
						id="deleteOptions"
						class="edit__delete-options-heading"
					>Select why you need to delete this vet clinic</label>
					<mat-radio-group
						[formControl]="questionaireControl"
						aria-labelledby="deleteOptions"
						class="edit__delete-options"
					>
						<mat-radio-button
							[value]="DeleteReason.NoLongerVisits"
							data-quat="input_reason1"
						>{{ petName || 'My pet' }} doesn't visit this vet anymore</mat-radio-button>
						<mat-radio-button
							[value]="DeleteReason.PetNeverVisited"
							data-quat="input_reason2"
						>{{ petName || 'My pet' }} <span class="u--underline">never</span> visited this vet
						</mat-radio-button>
						<mat-radio-button
							[value]="DeleteReason.AddedIncorrectClinic"
							data-quat="input_reason3"
						>Added the wrong vet</mat-radio-button>
						<mat-radio-button
							[value]="DeleteReason.Other"
							data-quat="input_reason4"
						>Other</mat-radio-button>
						<mat-error
							*ngIf="questionaireControl.invalid && submissionAttempted"
							class="edit__delete-validation"
						>Please make a selection</mat-error>
					</mat-radio-group>
				</div>
			</form>
			<section class="edit__actions m--gap-large">
				<mv-cancel-button
					class="edit__actions-cancel m--justify-end"
					(click)="close()"
				></mv-cancel-button>
				<button
					class="edit__actions-item m--delete m--justify-start m--bordered"
					data-quat="action_confirmDelete"
					(click)="confirmDelete()"
				>Delete</button>
			</section>
		</ng-container>
	</section>
</main>